import React, {useState, useRef, useEffect} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UI from "components/UI";
import StringUtil from "utils/StringUtil";
import UIUtils from "utils/UIUtils";
import CommonUtil from 'utils/CommonUtil';
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";
import ModalPopup from "components/modal";

function ContentsContainer() {
	const location = useLocation();
	const history = useHistory();
	const receivedData = (location.state as any)?.data;	
	const [PAY_CALL_YYYY ,setPAY_CALL_YYYY] = useState('');
	const [PAY_CALL_TITLE, setPAY_CALL_TITLE] = useState('');		
	const [REG_USERNM, setREG_USERNM] = useState('');
	const [REG_DATE, setREG_DATE] = useState('');
	//const [PAY_CALL_CONT, setPAY_CALL_CONT] = useState('')
	const PAY_CALL_CONT = useRef('');
	const [MODI_SEQ ,setMODI_SEQ] = useState('');
	const [BIZ_CD ,setBIZ_CD] = useState('');
	const [FILE_ID, setFILE_ID] = React.useState("");
    const [uploadId, setUploadId] = React.useState("");
	const [fileValue_tmp] = useState(new TbComFile());
	//const fileValue = React.useDeferredValue(fileValue_tmp);
	const [loadFinish,setLoadFinish] = useState(false);
	const [modalIsOpen, setmodalIsOpen] = useState(false);
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [formCheck,setFormCheck] = useState(false);
		  
    async function onClickList() {
	    let dataToSend = {};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1400',
	      state: { data: dataToSend }
	    });

    };   


    async function onClickDetail() {
		var vPAY_CALL_YYYY = receivedData.vPAY_CALL_YYYY;
		var vMODI_SEQ = receivedData.vMODI_SEQ;
		var vBIZ_CD = receivedData.vBIZ_CD;
        
	    let dataToSend = {
			vPAY_CALL_YYYY,
			vMODI_SEQ,
			vBIZ_CD
		};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1402',
	      state: { data: dataToSend }
	    });

    }; 

            
    async function onClickDelete() {
		if(await UIUtils.confirm('삭제하시겠습니까?')){	
			const response:any = await CommonUtil.execute({
	            url:"adm_1402_d002",
	            data: {
					"PAY_CALL_YYYY": PAY_CALL_YYYY,
					"MODI_SEQ": MODI_SEQ,
					"BIZ_CD": BIZ_CD,
				}
	        })
	        .then((response: any) => {          
				UIUtils.alert('정상처리되었습니다.').then();
	            onClickList();
	            
	       	}).catch((error) => {
	        	CommonUtil.showAxiosError(error);
	        	return;
	        	
	    	});
		}
    };   


	async function userFormCheck(){
		if (PAY_CALL_YYYY === '' || PAY_CALL_TITLE === '' || PAY_CALL_CONT.current === '' || PAY_CALL_CONT.current === '<p><br></p>') {
			setmodalIsOpen(true);
			//UIUtils.alert('필수 입력이 완료되지 않았습니다. 다시 확인해 주세요.').then();
			return;
		} 
	  
		if(await UIUtils.confirm('저장하시겠습니까?')){
			setFormCheck(true);  //폼 체크 여부 
			onFileUpload();
		}
	}; 
	            
	            
    async function onClickSave(sendParam) {
        const response:any = await CommonUtil.execute({
            url:"adm_1403_u001",
			data: sendParam
        })
		.then((response: any) => {
			UIUtils.alert('정상처리되었습니다.').then(()=>{
            	// @ts-ignore
            	onClickList();
            });
		}).catch((error) => {
	    	CommonUtil.showAxiosError(error);
	    	return;
       	});	  
       	
    }
    
    
	React.useEffect(() => {
		if(fileInfoList && formCheck) {

			let param = {
				PAY_CALL_YYYY : PAY_CALL_YYYY,	
				MODI_SEQ: MODI_SEQ,
				BIZ_CD: BIZ_CD,
				PAY_CALL_TITLE : PAY_CALL_TITLE,
				PAY_CALL_CONT : PAY_CALL_CONT.current,			
				FILE_ID:FILE_ID,
				FILE_INFO_LIST:fileInfoList,
			}
			
			onClickSave(param);
		}
	}, [fileInfoList])
	
	
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
		//console.log("arrayNew : "+JSON.stringify(arrayNew));
		//console.log("arrayDel : "+JSON.stringify(arrayDel));

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		};

		

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"ADD"
			}
			console.log("ADD = ", item.originalName);
			fileInfos.push(fileInfo);
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"DEL"
			}
			console.log("DEL = ", item.originalName);
			fileInfos.push(fileInfo);
			
		})

		setFileInfoList(fileInfos);
    }

    
	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

    
	async function initialize(){
		const response:any = await CommonUtil.execute({
            url:"adm_1402_r001",
            data: {
				"PAY_CALL_YYYY": receivedData.vPAY_CALL_YYYY,
				"MODI_SEQ": receivedData.vMODI_SEQ,
				"BIZ_CD": receivedData.vBIZ_CD,
			}
        })
        .then((response: any) => { 
			setPAY_CALL_TITLE(response.PAY_CALL_TITLE);
			
			let vfileInfoList = response.FILE_INFO_LIST;

			if(vfileInfoList!= null){
				vfileInfoList?.forEach((item, index) => {
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(item.DWLD_ID);
					fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(item.FILE_POLICY);
					fileDetail.setFileRpstr(item.FILE_RPSTR);
					fileDetail.setStrePath(item.STRE_PATH);
					fileDetail.setStreFileNm(item.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(item.FILE_EXTSN);
					fileDetail.setFileSize(Number(item.FILE_SIZE));
					fileDetail.setRegistDt(item.REGIST_DT);
					fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);
			
					fileValue_tmp.putTbComFileMapngDetailList(fileDetail);
				})
			}
			setLoadFinish(true);
			//setPAY_CALL_CONT(response.PAY_CALL_CONT);
			PAY_CALL_CONT.current = response.PAY_CALL_CONT;
			(document.activeElement as HTMLElement).blur();
			
       	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	        
	    	
    }    

	async function onClose() {
		setmodalIsOpen(false);
		
	}	        
                
	useEffect(() => {
		if(receivedData !== undefined){		
			setPAY_CALL_YYYY(StringUtil.defaultString(receivedData.vPAY_CALL_YYYY));
			setPAY_CALL_TITLE(StringUtil.defaultString(receivedData.vPAY_CALL_TITLE));
			setREG_USERNM(StringUtil.defaultString(receivedData.vREG_USERNM));
			setREG_DATE(StringUtil.defaultString(receivedData.vREG_DATE));
			//setPAY_CALL_CONT(StringUtil.defaultString(receivedData.vPAY_CALL_CONT));
			setMODI_SEQ(StringUtil.defaultString(receivedData.vMODI_SEQ));
			setBIZ_CD(StringUtil.defaultString(receivedData.vBIZ_CD));
			setFILE_ID(StringUtil.defaultString(receivedData.vuploadId));
			initialize();
			(document.activeElement as HTMLElement).blur();
		}
		
		return () => {
			
		}

    },[])	

    
	if(!loadFinish)
		return (
			<PageLoading />
		)
	else	    		
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={3}  lnbD2Idx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">지급 신청 안내 수정</h1>
					<form className="fo fo-col4" name="" action="" method="">
						<div className="inner">
							<div className="fo-item req">
								<p className="fo-key">지급신청안내년도</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={PAY_CALL_YYYY} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-2-5 req">
								<p className="fo-key">제목</p>
								<div className="fo-value">
								<input value={PAY_CALL_CONT.current} hidden/>
								<UIInput
										className={'tf tf-md w100p'}
										value={PAY_CALL_TITLE}
										placeholder={'제목을 입력하세요'}
										readOnly={false}
										valueChanged={(value) => setPAY_CALL_TITLE(value)}
										autoFocus={true}
									/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={REG_USERNM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-2-5">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={REG_DATE} placeholder={''} readOnly={true} />
								</div>
							</div>							
							<div className="fo-item fo-m-1-5 req">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<div className="ta-view w100p">
										<UI.SunEditor
											value={PAY_CALL_CONT.current}
											valueChanged={(value) => PAY_CALL_CONT.current = value}
											autoFocus={false}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-5">
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
									<div className='w100p'>
										<UI.FileUpload
										    value={fileValue_tmp}
											onCreationComplete={onCreationComplete}
											onUploadComplete={onUploadComplete}
											attrs={{
												ExtensionAllowOrLimit: "1",
												ImgPreView: "1", 
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</form>
					<div className="hz-root hz-right hz-gap5 mb10">
						<Button color="pri-o" size="sm" onClick={userFormCheck}>저장</Button>
						<Button color="gray-o" size="sm" onClick={onClickDelete}>삭제</Button>
						<Button color="gray-o" size="sm" onClick={onClickDetail}>취소</Button>
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>					

				</main>
			</div>
	        <ModalPopup
	            open={modalIsOpen}
	            title={'noTitle'}
	            size="alert"
	            onClose={() => onClose()}
	        >
	            <div className="modal-con">
	                <p className="msg">
	                    필수 입력이 완료되지 않았습니다.<br/>
	                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;다시 확인해 주세요.
	                </p>
	            </div>
	            <div className="modal-bottom">
	                <Button color='pri' size="md" onClick={() => setmodalIsOpen(false)}>확인</Button>
	            </div>
        	</ModalPopup>						
		</PageContainer>
	);
}
export default ContentsContainer;